"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var RayConfigurationBase_1 = require('./RayConfigurationBase');
/**
 * A {@code CentralRayWithWhiskersConfiguration} uses a long central ray and two shorter whiskers.
 * <p>
 * A central ray with short whiskers is often the best initial configuration to try but can make it impossible for the character
 * to move down tight passages. Also, it is still susceptible to the <a
 * href="../behaviors/RaycastObstacleAvoidance.html#cornerTrap">corner trap</a>, far less than the parallel configuration though.
 *
 * @param <T> Type of vector, either 2D or 3D, implementing the {@link Vector} interface
 *
 * @author davebaol
 */
var CentralRayWithWhiskersConfiguration = (function (_super) {
    __extends(CentralRayWithWhiskersConfiguration, _super);
    /**
     * Creates a {@code CentralRayWithWhiskersConfiguration} for the given owner where the central ray has the specified length and
     * the two whiskers have the specified length and angle.
     * @param owner the owner of this configuration
     * @param rayLength the length of the central ray
     * @param whiskerLength the length of the two whiskers (usually shorter than the central ray)
     * @param whiskerAngle the angle in radians of the whiskers from the central ray
     */
    function CentralRayWithWhiskersConfiguration(owner, rayLength, whiskerLength, whiskerAngle) {
        _super.call(this, owner, 3);
        this.rayLength = rayLength;
        this.whiskerLength = whiskerLength;
        this.whiskerAngle = whiskerAngle;
    }
    CentralRayWithWhiskersConfiguration.prototype.updateRays = function () {
        var ownerPosition = this.owner.getPosition();
        var ownerVelocity = this.owner.getLinearVelocity();
        var velocityAngle = this.owner.vectorToAngle(ownerVelocity);
        // Update central ray
        this.rays[0].start.copy(ownerPosition);
        this.rays[0].end.copy(ownerVelocity).nor().scale(this.rayLength).add(ownerPosition);
        // Update left ray
        this.rays[1].start.copy(ownerPosition);
        this.owner.angleToVector(this.rays[1].end, velocityAngle - this.whiskerAngle).scale(this.whiskerLength).add(ownerPosition);
        // Update right ray
        this.rays[2].start.copy(ownerPosition);
        this.owner.angleToVector(this.rays[2].end, velocityAngle + this.whiskerAngle).scale(this.whiskerLength).add(ownerPosition);
        return this.rays;
    };
    /** Returns the length of the central ray. */
    CentralRayWithWhiskersConfiguration.prototype.getRayLength = function () {
        return this.rayLength;
    };
    /** Sets the length of the central ray. */
    CentralRayWithWhiskersConfiguration.prototype.setRayLength = function (rayLength) {
        this.rayLength = rayLength;
    };
    /** Returns the length of the two whiskers. */
    CentralRayWithWhiskersConfiguration.prototype.getWhiskerLength = function () {
        return this.whiskerLength;
    };
    /** Sets the length of the two whiskers. */
    CentralRayWithWhiskersConfiguration.prototype.setWhiskerLength = function (whiskerLength) {
        this.whiskerLength = whiskerLength;
    };
    /** Returns the angle in radians of the whiskers from the central ray. */
    CentralRayWithWhiskersConfiguration.prototype.getWhiskerAngle = function () {
        return this.whiskerAngle;
    };
    /** Sets the angle in radians of the whiskers from the central ray. */
    CentralRayWithWhiskersConfiguration.prototype.setWhiskerAngle = function (whiskerAngle) {
        this.whiskerAngle = whiskerAngle;
    };
    return CentralRayWithWhiskersConfiguration;
}(RayConfigurationBase_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CentralRayWithWhiskersConfiguration;
//# sourceMappingURL=CentralRayWithWhiskersConfiguration.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/pawsong/gdx-ai.js/lib/steer/utils/rays/CentralRayWithWhiskersConfiguration.js
 ** module id = 899
 ** module chunks = 0
 **/